module.exports = "/static-assets/_next/static/images/img-dcb3e9c515-ba3c6be17f5b9d721e355719689b61e2.webp";